const selectors = {
  getContactInfoResult: (state) => state.contact.getContactInfoResult,
};

export default selectors;
